'use client';

import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { CenteredView } from '@/components/CenteredView/CenteredView';
import { ErrorPageIcon } from '@/components/ui/Icons/Icons';
import { Typography } from '@/components/ui/Typography/Typography.styles';
import { useBelow } from '@/hooks/useBelow';

import * as S from './Error.styles';

interface ErrorProps {
  reset?: () => void;
}

export const Error: FC<ErrorProps> = ({ reset }) => {
  const { t } = useTranslation();
  const isBelowMobileL = useBelow('mobileL');

  const handleReload = () => {
    if (reset) {
      reset();
    } else {
      window.location.reload();
    }
  };

  return (
    <CenteredView>
      <S.Content>
        <ErrorPageIcon />

        <S.Texts>
          <Typography variant={isBelowMobileL ? 'h1' : 'h0'}>
            {t('Error.title')}
          </Typography>
          <Typography variant={isBelowMobileL ? 'body3' : 'body2'}>
            {t('Error.subtitle')}
          </Typography>
        </S.Texts>

        <S.ReloadButton fullWidth onClick={handleReload}>
          {t('Error.button_label')}
        </S.ReloadButton>
      </S.Content>
    </CenteredView>
  );
};
